export default __webpack_public_path__ + "static/media/ms.e9fcd22a.svg";